import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { Amplify, Auth } from "aws-amplify";
// import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { authConfig, defaultAwsConfig } from "./config/aws-exports";
// import { CookieStorage } from "aws-amplify/utils";
import { UserProvider } from "./contexts/AuthContext";
import "./App.css";
import { EventProvider } from "./contexts/EventContext";

const PWA = false;

Amplify.configure(defaultAwsConfig);
Auth.configure(authConfig as any);

// cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage());

ReactDOM.createRoot(document.getElementById("root")!).render(
	<UserProvider>
		<EventProvider>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</EventProvider>
	</UserProvider>
);

// Register Service Worker
if ("serviceWorker" in navigator) {
	window.addEventListener("load", async () => {
		if (PWA) {
			try {
				const registration = await navigator.serviceWorker.register("/sw.js");
				console.log("Service Worker registered:", registration);
			} catch (error) {
				console.error("Service Worker registration failed:", error);
			}
		}
	});
}

// Ensure the event data type is specified for message event
interface ServiceWorkerMessageEvent {
	data: {
		type: string;
	};
}

if (navigator.serviceWorker) {
	navigator.serviceWorker.addEventListener("message", (event: MessageEvent) => {
		const typedEvent = event as ServiceWorkerMessageEvent; // Type assertion

		if (typedEvent.data && typedEvent.data.type === "updateManifestLink") {
			let manifestLink = document.querySelector('link[rel="manifest"]') as HTMLLinkElement;

			// If the <link rel="manifest"> does not exist, create it
			if (!manifestLink) {
				manifestLink = document.createElement("link");
				manifestLink.rel = "manifest";
				document.head.appendChild(manifestLink);
			}

			// Set the href to point to the dynamically cached manifest
			if (manifestLink) {
				manifestLink.href = "/manifest.json"; // Point to the dynamically cached manifest
			} else {
				console.error("Manifest link element could not be created.");
			}
		}
	});
}
